import { render, staticRenderFns } from "./dialogMarquee.vue?vue&type=template&id=4845d08b&"
import script from "./dialogMarquee.vue?vue&type=script&lang=js&"
export * from "./dialogMarquee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports